export default __webpack_public_path__ + "static/avatar-2cdda541d97c68dfa061dcf4bf1bb438.png";